import { Checkbox, DeprecatedClearSymbolIcon as ClearSymbol, IconButton, Input } from '@lokalise/louis';
import debounce from 'debounce';
import { useCallback } from 'react';

import { Container } from './styles';

type Value = {
    url: string;
    active: boolean;
};

export interface WebhookInputProps {
    id: string;
    value: Value;
    onChange: (value: Value, id: string) => void;
    onRemove: (url: string) => void;
}

const WebhookInput = ({ id, value, onChange, onRemove }: WebhookInputProps) => {
    const debouncedOnChange = debounce(onChange, 200);

    const handler = useCallback(debouncedOnChange, [debouncedOnChange]);

    return (
        <Container>
            <Input
                defaultValue={value.url}
                placeholder="https://yoursite.com/lokalise-webhook"
                onChange={(event) =>
                    handler(
                        {
                            ...value,
                            url: event.currentTarget.value,
                        },
                        id,
                    )
                }
            />
            <Checkbox
                aria-label="Activate webhook"
                checked={value.active}
                onChange={() =>
                    onChange(
                        {
                            ...value,
                            active: !value.active,
                        },
                        id,
                    )
                }
            />
            <IconButton ariaLabel="Remove webhook" onClick={() => onRemove(id)}>
                <ClearSymbol />
            </IconButton>
        </Container>
    );
};

export default WebhookInput;
